import { useLocation } from 'react-router';
import { parse as parseQuery } from 'query-string';
export function useQuery() {
    return parseQuery(useLocation().search);
}
